import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Play, Maximize } from 'lucide-react';

interface PlayPauseOverlayProps {
  onClick: () => void;
  isVisible: boolean;
  // Quando true, exibe um botão de tela cheia no canto superior direito.
  // Atrelado ao flag `haveFullScreen` do autoplayOverlay.
  showFullscreenButton?: boolean;
  onFullscreenClick?: () => void;
}

export const PlayPauseOverlay: React.FC<PlayPauseOverlayProps> = ({
  onClick,
  isVisible,
  showFullscreenButton = false,
  onFullscreenClick,
}) => {
  useLanguage();
  if (!isVisible) return null;

  return (
    <div
      className="absolute inset-0 flex items-center justify-center z-30 cursor-pointer bg-black/20 transition-opacity duration-200"
      onClick={onClick}
    >
      <div className="bg-white/90 rounded-full p-4 hover:bg-white hover:scale-110 transition-all duration-200 shadow-lg">
        <Play
          size={48}
          className="text-black"
          fill="black"
          strokeWidth={0}
        />
      </div>

      {/* Ações do overlay — canto inferior direito, só SVG clicável (sem
          fundo/borda). stopPropagation pra não disparar o play do overlay pai
          junto.
          O antigo botão de tela flutuante (PiP nativo) foi removido: hoje o
          recurso `havePictureInPicture` do autoplay é o mini player que segue o
          scroll, sem botão nenhum no overlay. */}
      <div className="absolute bottom-3 right-3 flex items-center gap-2">
        {showFullscreenButton && onFullscreenClick && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onFullscreenClick();
            }}
            className="p-1 bg-transparent border-0 cursor-pointer"
            aria-label={translateInterfaceText("Tela cheia")}
          >
            <Maximize size={20} className="text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)]" strokeWidth={2} />
          </button>
        )}
      </div>
    </div>
  );
};
